import { Dispatch, useState } from 'react';

function useModal<TDataType>(
  initialMode: boolean = false,
  initialState: TDataType | null = null,
): [boolean, Dispatch<boolean>, TDataType | null, Dispatch<TDataType>] {
  const [modalOpen, setModalOpen] = useState(initialMode);
  const [modalState, setModalState] = useState(initialState);
  return [modalOpen, setModalOpen, modalState, setModalState];
}
export default useModal;
